<template>
  <div class="card" v-if="$store.state.managerData || $store.state.userData">
    <div class="card-header">
      <h4 class="title">Edit Profile</h4>
    </div>
    <div class="card-content">
      <form>
        <div class="row">
          <div class="form-group col-md-12">
            <label>Email</label>
            <input type="text" name="email"
              v-validate="modelValidations.email"
              placeholder="No Email Currently Provided"
              v-model="model.email"
              class="form-control input-no-border">
            <small class="text-danger" v-show="email.invalid">
                {{ getError('email') }}
            </small>
          </div>
          <div class="col-md-12" v-if="!$route.path.includes('management')">
            <p-checkbox v-model="model.statementEmails" v-if="model.email != '' && !email.invalid">
              Go paperless and receive statements online<br>
              <small>By checking this box you agree to the terms in our <a href="static/files/PFTC_Online_Portal_Paperless_Disclosure.pdf" target="_blank">Paperless Disclosure</a></small>
            </p-checkbox>
          </div>
          <div class="form-group col-md-12">
            <label>New Account Password</label>
            <div class="input-group">
              <input :type="!showPassword ? 'password' : 'text'" placeholder="Password"
                name="password"
                v-validate="modelValidations.password"
                v-model.lazy="model.password"
                class="form-control input-no-border">
              <span class="input-group-btn">
                <button @click.prevent="showPassword=!showPassword" type="button" tabindex="-1" class="btn form-btn"
                v-html="passwordButton" >
                </button>
              </span>
            </div>
            <small class="text-danger" v-show="password.invalid">
                {{ getError('password') }}
            </small>
          </div>
          <div class="col-md-12">
            <hr>
            <label>Enter Your Current Password to Verify Changes</label>
            <div class="input-group">
              <input :type="!showCurrentPassword ? 'password' : 'text'"
                name="currentPassword"
                v-validate="modelValidations.currentPassword"
                placeholder="Current Password"
                v-model.lazy="model.currentPassword"
                class="form-control input-no-border">
              <span class="input-group-btn">
                <button @click.prevent="showCurrentPassword=!showCurrentPassword" type="button" tabindex="-1" class="btn form-btn"
                v-html="currentPasswordButton" >
                </button>
              </span>
            </div>
            <small class="text-danger" v-show="currentPassword.invalid">
                {{ getError('currentPassword') }}
            </small>
          </div>
        </div>
        <div class="text-center">
          <br>
          <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="validate">
            Update Profile
          </button><br><br>
          <transition name="fade" mode="out-in"><p class="alert alert-danger" v-if="serverError">{{ serverError }}</p></transition>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
    <el-table class="table-striped"
                      :data="[{'test': 5}]"
                      border
                      style="width: 100%">
    </el-table>
  </div>
</template>
<script>
  import { mapFields } from 'vee-validate'
  import Vue from 'vue'
  import { Table } from 'element-ui'

  Vue.use(Table) // Imported to fix iOS rendering issues
  export default {
    data () {
      return {
        showPassword: false,
        showCurrentPassword: false,
        serverError: false,
        model: {
          clientId: this.$route.path.includes('management') ? this.$store.state.managerData.ID : this.$store.state.userData.clientData.ClientId,
          email: this.$route.path.includes('management') ? this.$store.state.managerData.Email : this.$store.state.userData.emailSettings.Email || '',
          password: '',
          currentPassword: '',
          statementEmails: this.$route.path.includes('management') ? '' : !!this.$store.state.userData.emailSettings.EmailStatements
        },
        modelValidations: {
          email: {
            email: true
          },
          password: {
            min: 6
          },
          currentPassword: {
            required: true
          }
        }
      }
    },
    computed: {
      ...mapFields(['email', 'password', 'passwordRepeat', 'currentPassword']),
      passwordButton () {
        return this.showPassword ? '<i class="ti-lock"></i> Hide' : '<i class="ti-eye"></i> Show'
      },
      currentPasswordButton () {
        return this.showCurrentPassword ? '<i class="ti-lock"></i> Hide' : '<i class="ti-eye"></i> Show'
      }
    },
    methods: {
      updateProfile () {
        alert('Your data: ' + JSON.stringify(this.model))
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
       // 0000268: Users can go paperless without providing an email address.
      // On Go Paperless changes, re-run the validation for the email address.
      // Otherwise previous validation failures will continue to be shown when
      // it is blank and Go Paperless has been unselected (which is valid).
      updateEmailValidation () {
        this.$validator.fields.find({name: 'email'}).rules.required = this.model.statementEmails
        this.$validator.validate('email')
      },
      validate () {
        this.serverError = false
        // 0000268: Users can go paperless without providing an email address.
        // Make email required if user has selected to go paperless
        this.$validator.fields.find({name: 'email'}).rules.required = this.model.statementEmails
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.$emit('on-submit', this.model)
            this.$http.post(this.$route.path.includes('management') ? '/manager/update' : '/client/updateAccount', this.model)
            .then(response => {
              if (response.data.success === true) {
                this.model.currentPassword = this.model.password = ''
                if (!this.$route.path.includes('management')) {
                  this.$store.state.userData.emailSettings = response.data.emailSettings
                }
                this.$notify({
                  component: {
                    template: `<span><b>Success</b> - Account settings updated.</span>`
                  },
                  icon: 'ti-check',
                  horizontalAlign: 'right',
                  verticalAlign: 'bottom',
                  type: 'success'
                })
                this.$nextTick(() => this.$validator.reset())
              } else {
                throw response.data.error
              }
            })
            .catch(error => {
              this.serverError = error
            })
          }
        })
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Settings/Settings.vue